import templateData from './getTemplateData';
import Tooltip from 'tooltip.js';
import { getParametersFromUrl } from './queryStringHelper';
import jQuery from 'jquery';

const languagesList = templateData.languagesList.split(',');
const languageSelectorId = 'lang_selector';

export function hideLanguageSelector() {
	jQuery('.lang_selector').addClass('hidden');
}

export function showLanguageSelector() {
	jQuery('.lang_selector').removeClass('hidden');
	createLanguageSelector();
	updateLangSelectorTarget(getCurrentLangName());
}

function getCurrentLangName() {
	const languageCode = templateData.language;
	let currentLanguage = 'English';
	languagesList.forEach(lang => {
		const languageName = lang.split('-')[0];
		const locale = lang.split('-')[1];
		if (locale.split('_')[0] === languageCode) {
			currentLanguage = languageName;
		}
	})
  
	return currentLanguage;
}

function getLocaleByLanguageName(languageName) {
	let locale = 'en_US';
	languagesList.forEach(lang => {
		if (lang.split('-')[0] === languageName) {
			locale = `${lang.split('-')[1].split('_')[0]}_${templateData.country}`;
		}
	})
	return locale;
}

function updateLangSelectorTarget(languageName) {
	const selector = document.getElementById(languageSelectorId);

	if (templateData.isdesktop) {
		let innerHTML = selector.innerHTML.split(' ');
		innerHTML[0] = languageName;
		selector.innerHTML = innerHTML.join(' ');
	} else {
		selector.value = getLocaleByLanguageName(languageName);
	}
}

function addLanguageClickListener() {
	jQuery('body').on('click', '.lang-select-item', (event) => {
		const { currentTarget } = event;
		const languageName = currentTarget.getAttribute('data-language');
		const locale = currentTarget.getAttribute('data-locale');
		
		jQuery('.spinneroverlay').show();
		updateLangSelectorTarget(languageName);
		updatePageLanguageByLocale(locale);
	});
}

function createLanguageSelector() {
	if (templateData.isdesktop) {
		// initializing lang selector for desktop
		const htmlStr = generateTooltipHTML();
    
		const reference = document.getElementById(languageSelectorId);
		let tooltip = new Tooltip(reference, {   // eslint-disable-line
			title: htmlStr,
			trigger: 'click',
			placement: 'top',
			html: true,
			closeOnClickOutside: true
		});
		
		addLanguageClickListener();

	} else {
		// initializing lang selector for mobile
		initializeLangSelectorOptions();
    
		const selector = document.getElementById(languageSelectorId);
		selector.addEventListener('change', (event) => {
			updatePageLanguageByLocale(selector.value);
		})
	}
}

function generateTooltipHTML() {
	let htmlStr = '';
  
	languagesList.forEach(lang => {
		const languageName = lang.split('-')[0];
		const locale = `${lang.split('-')[1].split('_')[0]}_${templateData.country}`;
		const languageOption = `<p class="lang-select-item" data-language=${languageName} data-locale=${locale} id="lang-select-${languageName}">${languageName}</p>`;
		htmlStr += languageOption;
	})
  
	return htmlStr;
}

function initializeLangSelectorOptions() {
	const langSelector = document.getElementById(languageSelectorId);
	languagesList.forEach(lang => {
		const languageName = lang.split('-')[0];
		const locale = `${lang.split('-')[1].split('_')[0]}_${templateData.country}`;

		let option = document.createElement('option');
		let attribute = document.createAttribute('value');
		attribute.value = locale;
		option.setAttributeNode(attribute);
		let textNode = document.createTextNode(languageName);
		option.appendChild(textNode);
		langSelector.appendChild(option);
	});
}

function updatePageLanguageByLocale(locale) {
	const urlParams = getParametersFromUrl();
	urlParams['locale.x'] = locale;
	const updatedUrl = `${window.location.href.split('?')[0]}?${jQuery.param(urlParams)}`
	window.location.href = updatedUrl;
}



// WEBPACK FOOTER //
// ./utility/languageSelector.js